import { css } from "@emotion/react";

export const cssTextTruncate = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
